export function render({ node, api }) {
  const root = document.createElement('div');

  const header = document.createElement('div');
  header.className = 'ew-node-header';
  header.dataset.ewDrag = 'true';
  header.dataset.ewSelect = 'true';
  header.dataset.ewLink = 'true';

  const title = document.createElement('span');
  title.textContent = node.props?.title || 'Multiple Choice';

  const anchor = document.createElement('span');
  anchor.className = 'ew-link-anchor';
  anchor.dataset.ewLink = 'true';
  anchor.title = 'Link';

  header.append(title, anchor);

  const body = document.createElement('div');
  body.className = 'ew-node-body';

  const label = document.createElement('label');
  label.textContent = node.props?.label || 'Select all that apply';

  const list = document.createElement('div');
  list.className = 'ew-multi-choice';

  const getOptions = (source) =>
    Array.isArray(source?.props?.options) && source.props.options.length
      ? source.props.options
      : ['Alpha', 'Beta', 'Gamma'];

  const createList = (options) => {
    list.innerHTML = '';
    options.forEach((opt) => {
      const row = document.createElement('label');
      row.className = 'ew-multi-choice-option';
      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.value = String(opt);
      const text = document.createElement('span');
      text.textContent = String(opt);
      row.append(checkbox, text);
      list.appendChild(row);
    });
  };

  const syncSelection = (selected) => {
    const values = new Set(Array.isArray(selected) ? selected.map(String) : []);
    list.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
      checkbox.checked = values.has(checkbox.value);
    });
  };

  const readSelection = () =>
    Array.from(list.querySelectorAll('input[type="checkbox"]:checked')).map((box) => box.value);

  const onChange = () => {
    const selected = readSelection();
    api.setData({ selected });
    api.emit('node:input', { id: node.id, field: 'selected', value: selected });
  };

  list.addEventListener('change', onChange);

  const options = getOptions(node);
  createList(options);
  syncSelection(node.data?.selected || []);

  body.append(label, list);
  root.append(header, body);

  return {
    el: root,
    update: (next) => {
      title.textContent = next.props?.title || 'Multiple Choice';
      label.textContent = next.props?.label || 'Select all that apply';
      const nextOptions = getOptions(next);
      const currentOptions = Array.from(list.querySelectorAll('input[type="checkbox"]')).map(
        (box) => box.value
      );
      if (nextOptions.map(String).join('|') !== currentOptions.join('|')) {
        createList(nextOptions);
      }
      syncSelection(next.data?.selected || []);
    },
    cleanup: () => {
      list.removeEventListener('change', onChange);
    }
  };
}
